export const appEnv = (process.env.NEXT_PUBLIC_ENV as 'dev' | 'prod') ?? 'dev';
export const isProd = appEnv === 'prod';
export const companyUrl = process.env.NEXT_PUBLIC_URL_COMPANY;
export const talentUrl = process.env.NEXT_PUBLIC_URL_TALENT;
export const clarityID = process.env.NEXT_PUBLIC_CLARITY_ID;
export const hygraphAPI = process.env.NEXT_PUBLIC_HYGRAPH_API;
